import { ReactNode, useMemo } from 'react';

import { AuthProvider, AuthProviderProps } from 'react-oidc-context';

import { FeedbackAlert } from '@/components';
import { useClientConfig } from '@/hooks';
import { useConfigStore } from '@/stores';
import { configLoadFailedFeedbackProps } from '@/utils/config.ts';

const policy = 'b2c_1a_hrd_signup_signin';

export const AuthenticationProvider = ({ children }: { children: ReactNode }) => {
  const { loaded, error } = useConfigStore();
  const {
    B2C: { CLIENT_ID, TENANT },
  } = useClientConfig();

  const oidcConfig: AuthProviderProps = useMemo(
    () => ({
      authority: `https://${TENANT}.b2clogin.com/${TENANT}.onmicrosoft.com/${policy}/v2.0`,
      client_id: CLIENT_ID,
      redirect_uri: `${location.origin}/`,
      post_logout_redirect_uri: `${window.location.origin}/`,
      scope: `openid offline_access https://${TENANT}.onmicrosoft.com/sitecontrol-service-apis/Default`,
      onSigninCallback: () => {
        window.history.replaceState({}, document.title, window.location.pathname);
      },
    }),
    [CLIENT_ID, TENANT]
  );

  if (!loaded) return null;
  if (error) {
    return <FeedbackAlert {...configLoadFailedFeedbackProps(error)} />;
  }
  return <AuthProvider {...oidcConfig}>{children}</AuthProvider>;
};
